export const FontSizeBoundaryVal = {
    FONT_SIZE_MAX: 192,
    FONT_SIZE_MIN: 8,
    FONT_CHANGE_DIFF: 1,
};
